import { getNamesFromInput } from './getNamesFromInput.js';
import { agreementValidator, defaultSelectValidator, defaultValidator, innValidator, nameValidator, phoneValidator, } from './validators.js';
export const validatorObj = {
    typeForm: defaultValidator,
    surname: nameValidator,
    name: nameValidator,
    region: defaultSelectValidator,
    addressBranch: defaultSelectValidator,
    phone: phoneValidator,
    secondaryPhone: phoneValidator,
    birthday: defaultValidator,
    email: defaultValidator,
    fullName: nameValidator,
    inn: innValidator,
    partnerComments: defaultValidator,
    collectionCount: defaultValidator,
    comment: defaultValidator,
    acquiringType: defaultSelectValidator,
    feedbackType: defaultSelectValidator,
    feedbackMethod: defaultSelectValidator,
    serviceType: defaultSelectValidator,
    serviceDirection: defaultSelectValidator,
    meetingDay: defaultValidator,
    product: defaultValidator,
    localities: defaultValidator,
    consentDataProcessing: agreementValidator,
    annualRevenue: defaultValidator,
};
export const getObjectValidator = (inputs) => {
    const requiredInputs = getNamesFromInput(inputs.filter((_) => ('required' in _ ? _.required : false)));
    return Object.fromEntries(requiredInputs.map((_) => [_, validatorObj?.[_]]));
};
//# sourceMappingURL=getObjectValidator.js.map